import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricAvgPosCount extends MetricBase {
    constructor() {
        super({
            field: "metric_avgpos_count",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.avgPosCount.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.avgPosCount.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.avgPosCount.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricAvgPosCount;
